import Vue from 'vue'
import Questions from './components/Questions'
import Profile from './components/Profile'
import Lab from './components/Lab'
import TimePicker from './components/TimePicker'
import Modal from './components/Modal'

import VueTheMask from 'vue-the-mask'
import { library } from '@fortawesome/fontawesome-svg-core'
import {
    faEye,
    faEyeSlash,
    faEdit,
    faClock,
    faTimesCircle,
    faAngleDown,
    faAngleUp
} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

import './assets/css/style.css'

Vue.use(VueTheMask)

library.add(faEye, faEyeSlash, faEdit, faClock, faTimesCircle, faAngleDown, faAngleUp)

Vue.component('fa', FontAwesomeIcon)

Vue.use({
    install (Vue, options) {
        Vue.component('w-questions', Questions)
        Vue.component('w-profile', Profile)
        Vue.component('w-lab', Lab)
        Vue.component('w-timepicker', TimePicker)
        Vue.component('w-bottom-modal', Modal)
    }
})
